export class RefreshSessionRequest {
  public userId: string = '';
  public refreshToken: string = '';

  constructor(userId, refreshToken: string) {
    this.userId = userId;
    this.refreshToken = refreshToken;
  }
}
